import { Component, OnInit } from '@angular/core';
import { GeolocationService } from '../services/geolocationservice';

@Component({
  selector: 'app-existing-cust-card',
  templateUrl: './existing-cust-card.component.html',
  styleUrls: ['./existing-cust-card.component.css']
})
export class ExistingCustCardComponent implements OnInit {
  loanAmount: any;
  availableCardLimit: any;
  urlList: any;
  customerName:any;

  constructor(private service: GeolocationService) { }

  ngOnInit(): void {
      this.loanAmount = localStorage.getItem("loanAmount")
    this.availableCardLimit = localStorage.getItem("availableCardLimit")
    this.customerName = localStorage.getItem("customerName")
     }
  availNow(){
    this.service.getTvsmOnboardingCustUrl().subscribe((data:any)=>{
       if (typeof (data) === 'object') {
        console.log("event:" + JSON.stringify(data));
        this.urlList = JSON.parse(data.data);
        console.log("urllll"+this.urlList);
        console.log(JSON.stringify(this.urlList))  
        window.location.href= this.urlList[0].instaCardNavigation;
      if (data.statusCode == 'EX') {
         // this.loader = false;
       } else if (data.statusCode == 'SR') {
        //  this.loader = false;
        }

      }
     });
    }
    creditLimitPercentage() {
      return Math.round((this.availableCardLimit / this.loanAmount) * 100);
    }
  }
